<!-- <app-sidebar></app-sidebar> -->
<!-- <app-header
*ngIf="router =='!true'"></app-header> -->
<app-header></app-header>
<!--*ngIf="router =='!true'"-->
<div class="page-wrapper">
  <!-- Page Content-->
  <div class="page-content-tab">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <div class="page-title-box">
<!--            <p>{{window.location}}</p>-->
          </div><!--end page-title-box-->
        </div>
        <router-outlet></router-outlet>
      </div>
      <app-off-canvas></app-off-canvas>
    </div>
    <app-footer></app-footer>
  </div>
</div>
